window.initCareerPositions = function(sectionId) {
  const section = document.getElementById(sectionId);
  if (!section) return;

  // Reveal Animation
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    },
    { threshold: 0.1 }
  );
  section.querySelectorAll('.career-positions-reveal').forEach((el) => observer.observe(el));

  // Filter Logic
  const filterBtns = section.querySelectorAll('.career-positions-filter-btn');
  const jobCards = section.querySelectorAll('.career-positions-card');
  const grid = section.querySelector('.career-positions-grid');
  // Skip height-lock on the mobile-slider variant — cards stay in horizontal flex,
  // so the vertical natural height isn't driven by which cards match the filter.
  const isMobileSlider = grid && grid.classList.contains('mobile-slider');

  // Lock the grid to its tallest natural height (all cards visible). This eliminates
  // page-wide layout shift when a filter shows fewer cards — sections below stay put.
  // Trade-off: when a filter matches few cards, there is empty space below them.
  let lockedHeight = 0;
  const captureMaxHeight = () => {
    if (lockedHeight > 0 || !grid || isMobileSlider) return;
    // Make sure every card is laid out for the measurement.
    jobCards.forEach((card) => {
      card.style.display = 'block';
      card.style.opacity = '1';
    });
    const h = grid.getBoundingClientRect().height;
    if (h > 0) {
      lockedHeight = h;
      grid.style.minHeight = h + 'px';
    }
  };

  // Defer until the reveal animation (opacity/transform over 0.6s) has settled.
  if (grid && !isMobileSlider) {
    const schedule = () => setTimeout(captureMaxHeight, 700);
    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });
  }

  filterBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      // Remove active class and aria-pressed from all buttons in THIS section
      filterBtns.forEach((b) => {
        b.classList.remove('active');
        b.setAttribute('aria-pressed', 'false');
      });

      // Add active class and aria-pressed to clicked button
      btn.classList.add('active');
      btn.setAttribute('aria-pressed', 'true');

      // If a user clicks before the deferred capture has run, capture NOW
      // (the page is interactive, so the grid is at its full natural height).
      if (lockedHeight === 0) captureMaxHeight();

      const filterValue = btn.getAttribute('data-filter');

      // Apply all show/hide changes synchronously in one pass. min-height is already
      // locked to the tallest state, so the grid does not change size and sections
      // below the grid do not shift.
      jobCards.forEach((card) => {
        const cardLocation = card.getAttribute('data-location');
        const shouldShow = filterValue === 'all' || cardLocation.includes(filterValue);

        if (shouldShow) {
          card.style.display = 'block';
          card.style.opacity = '1';
        } else {
          card.style.display = 'none';
          card.style.opacity = '0';
        }
      });
    });
  });
};

// Auto-initialize all career-positions sections on page load
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('[id^="shopify-section-"]');
    sections.forEach(function(section) {
      if (section.querySelector('.career-positions-section')) {
        window.initCareerPositions(section.id);
      }
    });
  });
})();
